module.exports = __webpack_public_path__ + "static/img/history.27adfa8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/aboutUs/history.png
// module id = ENJJ
// module chunks = 1